module.exports = __webpack_public_path__ + "img/round-list.f93c4ff3.svg";